import { useInfiniteSearchCategoriesQuery } from '../query/useSearchCatergoriesQuery';
import { OptionType } from '../../common/queryClient';
import { InfiniteSearchSelect, SelectProps } from '../../common/components';

export interface CategoryAutoCompleteProps extends SelectProps {
  classifierId?: number;
  classifierCode?: string;
  defaultOption?: OptionType;
}

interface CategorySearchOptions {
  classifierId?: number;
  classifierCode?: string;
}

const useCategorySearch = (term: string, options?: CategorySearchOptions) =>
  useInfiniteSearchCategoriesQuery(
    term,
    options?.classifierId,
    options?.classifierCode,
  );

export function CategoryAutoComplete(props: CategoryAutoCompleteProps) {
  const { classifierId, classifierCode, ...rest } = props;

  return (
    <InfiniteSearchSelect
      {...rest}
      searchOptions={{ classifierCode, classifierId }}
      useSearchHook={useCategorySearch}
    />
  );
}
